import styled, { css } from 'styled-components';

// Components
import { DayPicker } from '../Calendar/DayPicker';
import { Typography } from '../../display/Typography';
import { ButtonIconBackground } from '../buttons/ButtonIconBackground';

// Papelera para vaciar la fecha. Mismo botón que el de los filtros de las tablas
// (3.4rem). Hereda `align-self: flex-end`; lo subimos 0.3rem
// ((4rem input − 3.4rem) / 2) para CENTRARLO en altura respecto al input, con una
// pequeña separación a su izquierda (sumada al gap del contenedor).
export const ClearDateButton = styled(ButtonIconBackground)`
  align-self: flex-end;
  margin-bottom: 0.3rem;
  margin-left: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const Container = styled.div`
  position: relative;
`;

export const ContainerCalendar = styled.div``;

export const ContainerInputs = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
`;

export const SmallContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const Label = styled(Typography)`
  white-space: nowrap;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

type inputBorder = {
  borderError?: boolean;
  isFocus?: boolean;
};

export const InputDate = styled.input<inputBorder>`
  width: 15rem;
  height: 4rem;
  border-radius: 0.5rem;
  padding: 0 1rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  ${(props) =>
    props.disabled &&
    css`
      font-weight: ${props.theme.fontWeight.medium};
      color: ${props.theme.colors.greyDark};
      background-color: ${props.theme.colors.greyLight};
      border: none;
    `}
  ${(props) =>
    props.borderError &&
    props.borderError &&
    css`
      border: 0.1rem solid ${props.theme.colors.lightCoralRed};
    `}

  &:focus {
    outline: 0.1rem solid ${({ theme }) => theme.colors.black};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const Calendar = styled(DayPicker)`
  position: absolute;
  margin-top: ${({ theme }) => theme.spaces.xxxs}rem;
  left: -2.5rem;
  z-index: 999;
  padding: 2.5rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    position: fixed;
    max-height: 65rem;
    bottom: 0;
    margin: 0;
    left: 0;
    width: 100%;
    padding: 3rem 17rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    top: 25rem;
    left: 0;
    padding: 5rem 10rem;
    padding-bottom: 1rem;
    max-height: 100%;
  }
`;

export const InputTime = styled.div<inputBorder>`
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 0 1rem;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.white};
  ${(props) =>
    props['aria-disabled'] &&
    css`
      font-weight: ${props.theme.fontWeight.medium};
      color: ${props.theme.colors.greyDark};
      background: ${props.theme.colors.greyLight};
    `}
  border: ${(props) =>
    props['aria-disabled']
      ? `none`
      : props[`borderError`]
        ? `0.1rem solid ${props.theme.colors.lightCoralRed}`
        : `0.1rem solid ${props.theme.colors.black}`};
  outline: none;
  ${({ isFocus }) =>
    isFocus &&
    css`
      outline: 0.1rem solid ${({ theme }) => theme.colors.black};
    `}
`;

export const InputNumberHours = styled.input`
  text-align: right;
  width: 2ch;
  padding: 0;
  appearance: none;
  border: none;
  background-color: transparent;
  ${(props) =>
    props.disabled &&
    css`
      font-weight: ${props.theme.fontWeight.medium};
      color: ${props.theme.colors.greyDark};
    `}
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const InputNumberMinutes = styled.input`
  width: 2ch;
  padding: 0;
  appearance: none;
  border: none;
  background-color: transparent;
  ${(props) =>
    props.disabled &&
    css`
      font-weight: ${props.theme.fontWeight.medium};
      color: ${props.theme.colors.greyDark};
    `}
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const Span = styled.span`
  font-size: ${({ theme }) => theme.fontSize.S};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
